import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "../ui/button";
import { CurrentSessionData } from "../../hooks/userSession";

interface ModernHeaderProps {
  currentSession: CurrentSessionData;
}

const ModernHeader = ({ currentSession }: ModernHeaderProps) => {
  const isLoggedIn = currentSession.userSessionState.isLoggedIn;
  const userName = currentSession.userSessionState.fullName;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 max-w-screen-xl items-center justify-between">
        <div className="flex items-center space-x-4">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/img/logo.png"
              alt="La Dalia Café"
              className="h-14 w-auto"
            />
          </Link>
        </div>

        <nav className="hidden md:flex items-center space-x-6">
          {isLoggedIn ? (
            <>
              <span className="text-sm font-medium text-muted-foreground">
                Hola, {userName}
              </span>
              <Button variant="ghost" size="sm" asChild>
                <Link to="/customer/list">Buscar Clientes</Link>
              </Button>
              <Button variant="ghost" size="sm" asChild>
                <Link to="/customer/new">Registrar Cliente</Link>
              </Button>
              <Button variant="ghost" size="sm" asChild>
                <Link to="/customer/update-phone">Actualizar Teléfono</Link>
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => currentSession.logout()}
              >
                Cerrar Sesión
              </Button>
            </>
          ) : (
            <>
              <Link
                to="/myPoints"
                className="text-sm font-medium hover:text-primary transition-colors"
              >
                Mis Puntos
              </Link>
              <Button variant="ghost" size="sm" asChild>
                <Link to="/employee/login">Acceso Empleados</Link>
              </Button>
            </>
          )}
        </nav>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <Button
            variant="ghost"
            size="sm"
            aria-label={isMobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen((open) => !open)}
          >
            {isMobileMenuOpen ? (
              <X className="h-5 w-5" />
            ) : (
              <Menu className="h-5 w-5" />
            )}
          </Button>
        </div>
      </div>

      {/* Mobile menu panel */}
      {isMobileMenuOpen && (
        <nav className="md:hidden border-t bg-background">
          <div className="container flex flex-col space-y-1 py-4 max-w-screen-xl">
            {isLoggedIn ? (
              <>
                <span className="px-1 py-2 text-sm font-medium text-muted-foreground">
                  Hola, {userName}
                </span>
                <Button
                  variant="ghost"
                  size="sm"
                  className="justify-start"
                  asChild
                >
                  <Link to="/customer/list" onClick={closeMobileMenu}>
                    Buscar Clientes
                  </Link>
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  className="justify-start"
                  asChild
                >
                  <Link to="/customer/new" onClick={closeMobileMenu}>
                    Registrar Cliente
                  </Link>
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  className="justify-start"
                  asChild
                >
                  <Link to="/customer/update-phone" onClick={closeMobileMenu}>
                    Actualizar Teléfono
                  </Link>
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  className="justify-start"
                  onClick={() => {
                    closeMobileMenu();
                    currentSession.logout();
                  }}
                >
                  Cerrar Sesión
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="ghost"
                  size="sm"
                  className="justify-start"
                  asChild
                >
                  <Link to="/myPoints" onClick={closeMobileMenu}>
                    Mis Puntos
                  </Link>
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  className="justify-start"
                  asChild
                >
                  <Link to="/employee/login" onClick={closeMobileMenu}>
                    Acceso Empleados
                  </Link>
                </Button>
              </>
            )}
          </div>
        </nav>
      )}
    </header>
  );
};

export default ModernHeader;